import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { map, Observable } from "rxjs"
import { PrintProcedureInstanceInfoBase } from "../../model/print/print-procedure-instance-info.model"
import { ProcedureInstanceService } from "../procedure-instance/procedure-instance.service"

@Injectable({
    providedIn: 'root'
})
export class EFormPrintService {

    protected resourceUrl: string = "/rest/privatearea/printform"

    constructor(private http: HttpClient, protected procedureInstanceService: ProcedureInstanceService) { }

    findFullProcedureInstanceInfo(serviceInstanceCode: number, procedureInstanceCode: number, secret: string): Observable<PrintProcedureInstanceInfoBase> {

        return this.http.get<PrintProcedureInstanceInfoBase>(`${this.resourceUrl}/findFullProcedureInstanceInfo/${serviceInstanceCode}/${procedureInstanceCode}?secret=${secret}`).pipe(map(result => {
            let res = PrintProcedureInstanceInfoBase.from(result)
            this.procedureInstanceService.processFieldsNameInfo(res.procedureInstanceTOs)
            return res
        }))

    }

}